<template lang="pug">
  .coach-avatar-top(:style="styleTop")
    .avatar-detail-background(:style="styleAvatar")
      span(class="is-overload" v-if="coach.isAcceptableNewStudent === false")
        img(:src="imageSrc")
    .avatar-detail-background-filter(v-if="isShowFilter")
    .name-and-dance-kinds
      div.coach-name
        span(class="is-new" v-if="coach.checkIsNew")
          img(:src="imageSrc2")
        span {{ coach.name }}
      coach-detail-dance-kinds(:coach="coach")
</template>

<style lang="scss" scoped>
.coach-avatar-top {
  width: 100%;
  height: 460px;
  position: absolute;
  top: 0;
  left: 0;
  display: flex;

  .avatar-detail-background {
    width: 100%;
    height: 460px;
    margin: auto;
    background-size: cover;
    display: block;
    background-position: 50%;
    background-repeat: no-repeat;

    .is-overload {
      position: absolute;
      left: calc(100% - 170px);
      top: 0px;
    }
  }
  .avatar-detail-background-filter {
    width: 100%;
    height: 460px;
    position: absolute;
    top: 0;
    left: 0;

    background: linear-gradient(
      -180deg,
      rgba(22, 23, 26, 0.1) 1%,
      rgba(22, 23, 26, 0.2) 100%
    );
  }

  .name-and-dance-kinds {
    width: 100%;
    text-align: center;
    position: absolute;
    bottom: 24px;

    .coach-name {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      @extend %title;
      font-size: 32px;
      line-height: 28px;
      margin-bottom: 16px;

      .is-new {
        margin-bottom: 8px;
      }
    }
  }
}
</style>

<script>
import CoachDetailDanceKinds from '@/components/molecules/CoachDetailDanceKinds'

export default {
  components: { CoachDetailDanceKinds },
  props: {
    coach: { type: Object, required: false },
  },
  computed: {
    imageSrc() {
      return require(`@/assets/retina-images/is_overload2.png`)
    },
    imageSrc2() {
      return require(`@/assets/retina-images/is_new2.png`)
    },
    styleTop() {
      return this.isDefaulCoachtAvatar()
        ? { 'background-color': '#494E5C' }
        : ''
    },
    styleAvatar() {
      if (!this.coach.avatarImageUrl) return {}
      if (this.isDefaulCoachtAvatar()) {
        var size = window.innerWidth / 2 + 40
        return {
          'background-image': `url(${this.coach.avatarImageUrl})`,
          width: `${size}px`,
          height: `${size}px`,
        }
      }
      return { 'background-image': `url(${this.coach.avatarImageUrl})` }
    },
    isShowFilter() {
      return !this.isDefaulCoachtAvatar()
    },
  },
  methods: {
    isDefaulCoachtAvatar() {
      if (!this.coach.avatarImageUrl) return false
      return this.coach.avatarImageUrl.indexOf('default_') !== -1
    },
  },
}
</script>
